const accordions = (): void => {
  const selectors = {
    accordionSection: '[data-accordions]',
    accordionAccordion: '[data-accordion]',
    accordionAccordionHeading: '[data-accordion-heading]',
    accordionAccordionContent: '[data-accordion-content]',
  };

  const classes = {
    accordionOpen: 'accordions__accordion--open',
  };

  const openAccordion = (
    accordion: HTMLElement,
    accordionInner: HTMLElement
  ): void => {
    accordion.classList.add(classes.accordionOpen);
    accordionInner.style.maxHeight = accordionInner.scrollHeight + 'px';
  };

  const closeAccordion = (
    accordion: HTMLElement,
    accordionInner: HTMLElement
  ): void => {
    accordion.classList.remove(classes.accordionOpen);
    accordionInner.style.maxHeight = null as any;
  };

  const accordionSections = document.querySelectorAll<HTMLElement>(
    selectors.accordionSection
  );

  accordionSections.forEach((section) => {
    const accordions = section.querySelectorAll<HTMLElement>(
      selectors.accordionAccordion
    );

    accordions.forEach((accordion) => {
      const heading = accordion.querySelector<HTMLElement>(
        selectors.accordionAccordionHeading
      );
      const content = accordion.querySelector<HTMLElement>(
        selectors.accordionAccordionContent
      );

      if (heading && content) {
        heading.addEventListener('click', () => {
          if (content.style.maxHeight) {
            closeAccordion(accordion, content);
          } else {
            accordions.forEach((otherAccordion) => {
              const otherContent: any =
                otherAccordion.querySelector<HTMLElement>(
                  selectors.accordionAccordionContent
                );
              closeAccordion(otherAccordion, otherContent);
            });
            openAccordion(accordion, content);
          }
        });
      }
    });

    window.addEventListener('resize', () => {
      accordions.forEach((accordion: HTMLElement) => {
        const content = accordion.querySelector<HTMLElement>(
          selectors.accordionAccordionContent
        );
        if (content && content.style.maxHeight) {
          openAccordion(accordion, content);
        }
      });
    });
  });
};

export default accordions;
